<template>
	<div>
		
		<v-row>
			<v-col cols="4" class="tour-step-20">
				<div v-html="faseWithStati?.descrizione"></div>
			</v-col>
			
			<v-col class="tour-step-19">
				<div class="d-flex justify-end align-center mb-3">
					<div class="font-weight-medium mr-3">Stato Fase {{ faseWithStati?.ordinamento }}</div>
					<v-sheet
						v-if="(isAccountManager && action == 'show') || (isCliente)"
						rounded
						:color="coloreStato"
						class="mr-3 px-3 py-1 white--text"
					
					>
						{{ nomeStato }}
					</v-sheet>
				
					<v-badge
						v-if="isAccountManager && action == 'edit'"
						:value="praticaDiff.includes(`id_stato_fase_${faseWithStati?.ordinamento}`)"
						class="d-block"
						color="info"
						overlap
						right
						icon="mdi-pencil"
					>
						<v-select
							:items="faseWithStati?.stati"
							item-text="nome"
							item-value="id"
							v-model="stato"
							outlined
							dense
							hide-details
							:color="coloreStato"
							return-object
							:disabled="disabled"
							:readonly="action == 'show'"
						></v-select>
					</v-badge>
				</div>
				<div
					v-html="descrizioneStato"
					class="descrizione_stato d-flex flex-column align-end"
					:style="`color: ${coloreStato}`"
				></div>
			</v-col>
		</v-row>
		
		<div
			:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"
			class="mt-5 mb-8"
		></div>
		
	</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	props: ['faseWithStati', 'pratica', 'disabled', 'action', 'praticaDiff'],
	data() {
		return {
			stato: {
				id: null,
				nome: null
			},
			// ciSonoAggiornamenti: false,
			isSettingPratica: false,
		}
	},
	
	created() {
		this.isSettingPratica = true;
		this.stato.id = this.faseWithStati ? JSON.parse(JSON.stringify(this.pratica[`id_stato_fase_${this.faseWithStati.ordinamento}`])) : null;
		this.stato.nome = this.faseWithStati?.stati.find(stato => stato.id == this.stato.id)?.nome;
		// this.ciSonoAggiornamenti = JSON.parse(JSON.stringify(this.pratica[`ci_sono_aggiornamenti_fase_${this.faseWithStati.ordinamento}`]));
		this.isSettingPratica = false;
	},
	
	watch: {
		'stato.id': function (newId) {
			if (!this.isSettingPratica) {
				this.$emit('update-id-stato', newId);
			}
		},
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente'
		}),
		coloreStato() {
			if (!this.isSettingPratica) return this.faseWithStati?.stati.find(stato => stato.id == this.stato.id)?.codice_colore;
		},
		nomeStato() {
			if (!this.isSettingPratica) return this.faseWithStati?.stati.find(stato => stato.id == this.stato.id)?.nome;
		},
		descrizioneStato() {
			if (!this.isSettingPratica) return this.faseWithStati?.stati.find(stato => stato.id == this.stato.id)?.descrizione;
		}
	},
}
</script>

<style scoped>

</style>